import type { SupplyChainContent } from '@/lib/api/fetch-supply-chain';
import DynamicImage from '@/components/dynamic-image';

export default function ProductTabsSupplyChains({ supplyChain }: { supplyChain: SupplyChainContent }) {
    const mediaUrl = supplyChain.c_image ? supplyChain.c_image : undefined;
    const supplyChainName = supplyChain.c_pimSupplyChainName ?? '';
    const supplyChainDescription = supplyChain.c_pimSupplyChainDescription ?? '';

    return (
        <div className="space-y-6 flex gap-20 justify-between max-lg:flex-col-reverse max-lg:gap-6">
            {mediaUrl && (
                <div className="flex flex-col items-center flex-4">
                    <DynamicImage
                        src={mediaUrl}
                        alt=""
                        className="rounded-md object-cover aspect-[4/5]"
                        loading="lazy"
                        widths={{ base: '100vw', lg: 420 }}
                    />
                </div>
            )}
            <div className="flex flex-col justify-center flex-7">
                {supplyChainName && <p className="label-l text-neutral-40">{supplyChainName}</p>}
                {supplyChainDescription && (
                    <div
                        className="body-copy-l text-neutral-10 mt-4"
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{ __html: supplyChainDescription }}
                    />
                )}
            </div>
        </div>
    );
}
